var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.deleteOption)?_c('b-button',{staticClass:"btn-lg",attrs:{"disabled":!_vm.canDelete,"variant":"danger"},on:{"click":() => _vm.deleteRelatie()}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n    Verwijder\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }